import { setup } from './model/auth'

export { signOutMutation } from './api/signOutMutation'

export const $$me = { setup }
